/**
 * @description
 * Cookie strategy interface.
 */
export class CookieStrategy {
  set() {
    throw new Error('Set method not implemented.');
  }

  get() {
    throw new Error('Get method not implemented.');
  }

  erase() {
    throw new Error('Erase method not implemented.');
  }
}
